import background from "../assets/onlyfriends_bg.png";

function Support() {
  return (
    <div
      style={{
        backgroundColor: "rgb(173, 207, 255)",
        position: "absolute",
        top: 0,
        left: 0,
        height: "100%",
        width: "100%",
      }}
      className="font-face-gm"
    >
      <p>We do not offer support...</p>
      <p>just kidding email us at support@onlyfriendswidget.com</p>
    </div>
  );
}

export default Support;
